import React from 'react';
import { GameAssetsProvider } from '../../XXX/context/GameAssetContext';
import ComboInputPractice from '../../LandingPage/ComboInputPractice/ComboInputPractice';
import './ComboInputPracticePage.css';

const ComboInputPracticePage: React.FC = () => {
  return (
    <GameAssetsProvider>
      <div className="combo-input-practice-page">
        <div className="page-header">
          <h1>Combo Input Practice</h1>
          <p className="page-description">
            Practice your champion combos with a typing-test style interface. 
            Select predefined combos or create your own sequences to improve your muscle memory.
          </p>
        </div>
        
        <div className="practice-content">
          <ComboInputPractice />
        </div>
      </div>
    </GameAssetsProvider>
  );
};

export default ComboInputPracticePage;